import React from 'react';

import { addModal } from '@/exceed';

import AddUserEnrollmentsModal from '../../components/addUserEnrollmentsModal';

export default async ({
  courseId,
  courseTitle,
  resetBaseSelectedUsers,
  statuses,
  baseEnrolledUsers,
}) => {
  await addModal({
    component: (
      <AddUserEnrollmentsModal
        courseId={courseId}
        courseTitle={courseTitle}
        resetBaseSelectedUsers={resetBaseSelectedUsers}
        statuses={statuses}
        baseEnrolledUsers={baseEnrolledUsers}
      />
    ),
    isFullScreen: true,
    hasCloseButton: true,
  });
};
